export default __webpack_public_path__ + "static/media/mca-logo-transparent.96bf3d13.png";